/*
 * @Author: MX
 * @Date: 2021-03-16 15:24:00
 * @Description:
 */
/**
 * @desc 自定义过滤器
 */
import store from "@/store";
let langs = null; // 国际化数据
// 国际化过滤器
export function lang(str) {
  langs = store.state.base.langJson || {};
  return langs[str] || str || "";
}